<template>
	<div>
		<v-text-field label="Password" :value="value" @input="updateValue($event.target.value)" :type="hidePassword ? 'password' : 'text'">
			<template slot="append-outer">
				<v-btn v-show="!hidePassword" small flat @click="hidePassword = true">Hide</v-btn>
				<v-btn v-show="hidePassword" small flat @click="hidePassword = false">Show</v-btn>
			</template>
		</v-text-field>
		<v-btn @click="_generatePassword()">Generate password</v-btn>
	</div>
</template>

<script>
	import { generatePassword } from '@/utils/generatePasswordUtil';
	export default {
        props: {
            value: {
                type: String
            }
        },
		data() {
			return {
				hidePassword: false
			}	
		},
        created() {
            if (!this.value) 
				this._generatePassword();
        },
		methods: {
            updateValue(value) {
                this.$emit('input', value);
            },
			_generatePassword() {
				this.updateValue(generatePassword());
				this.hidePassword = false;
			}
		}
	};
</script>

<style>
</style>